import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { TOffer } from 'shared/types/TRankingService';

import { modifyPreApprovalOfferBadges, modifyPreApprovalOfferSummaries } from 'entities/scenario';

import { getOfferStatus } from './getOfferStatus';

export const mergeMplOfferToRankingOffer = (mplOffer: MPLPreApprovalOffer, offer: TOffer): TOffer => {
  return {
    ...offer,
    logo: mplOffer.organizationLogo,
    badges: modifyPreApprovalOfferBadges(mplOffer.badges) as unknown as TOffer['badges'],
    order: mplOffer.order,
    summaries: modifyPreApprovalOfferSummaries(mplOffer.summaries, mplOffer.productType),
    loansStatus: mplOffer.apiStatus,
    status: getOfferStatus(mplOffer),
    group: 'Online',
  };
};
